"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Board = void 0;
class Board {
    constructor() {
        this.a2 = undefined;
        this.a1 = undefined;
        this.a3 = undefined;
        this.a4 = undefined;
        this.a5 = undefined;
        this.a6 = undefined;
        this.a7 = undefined;
        this.a8 = undefined;
        this.b1 = undefined;
        this.b2 = undefined;
        this.b3 = undefined;
        this.b4 = undefined;
        this.b5 = undefined;
        this.b6 = undefined;
        this.b7 = undefined;
        this.b8 = undefined;
        this.c1 = undefined;
        this.c2 = undefined;
        this.c3 = undefined;
        this.c4 = undefined;
        this.c5 = undefined;
        this.c6 = undefined;
        this.c7 = undefined;
        this.c8 = undefined;
        this.d1 = undefined;
        this.d2 = undefined;
        this.d3 = undefined;
        this.d4 = undefined;
        this.d5 = undefined;
        this.d6 = undefined;
        this.d7 = undefined;
        this.d8 = undefined;
        this.e1 = undefined;
        this.e2 = undefined;
        this.e3 = undefined;
        this.e4 = undefined;
        this.e5 = undefined;
        this.e6 = undefined;
        this.e7 = undefined;
        this.e8 = undefined;
        this.f1 = undefined;
        this.f2 = undefined;
        this.f3 = undefined;
        this.f4 = undefined;
        this.f5 = undefined;
        this.f6 = undefined;
        this.f7 = undefined;
        this.f8 = undefined;
        this.g1 = undefined;
        this.g2 = undefined;
        this.g3 = undefined;
        this.g4 = undefined;
        this.g5 = undefined;
        this.g6 = undefined;
        this.g7 = undefined;
        this.g8 = undefined;
        this.h1 = undefined;
        this.h2 = undefined;
        this.h3 = undefined;
        this.h4 = undefined;
        this.h5 = undefined;
        this.h6 = undefined;
        this.h7 = undefined;
        this.h8 = undefined;
    }
}
exports.Board = Board;
Board.numbers = ['1', '2', '3', '4', '5', '6', '7', '8'];
Board.letters = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h'];
